import React, { useState, useEffect } from 'react';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import {UsuariosExpatriadosScreen} from './screen';
import { UsuariosAdapter, Usuario } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

export const UsuariosExpatriadosContainer = (props:any) => {

	const {translate} = props;
	const api = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();

	let [ usuarios, setUsuarios ] = useState<any>([]);
	let [permisosUser, setPermisosUser] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getUsuarios();
	}, []);

	const getUsuarios = async () => {
		try {
			result = await api.ListarUsuariosExpatriados();
			if(result.data && result.data!=="")
			{
				setUsuarios([ ...result.data ]);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const adjuntarFicherosExpatriado = async (idEmpleado:number,ficheros:any)=>{
		try {
			const result:any = await api.AdjuntarFicherosExpatriado(idEmpleado,ficheros);

			if(result.data && result.data!=="")
			{
				launchNotification({type:"success",title:translate('adjuntos'),message:`${translate('msg-notificacion-adjuntar-expatriados')}.`})
			}else{
				resultError();
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception);
		}
	}

	const updateUsuario = async (usuario: any, ficherosExpatriado: any) => {
		try {
			result = await api.ModificarUsuarioExpatriado(usuario);
			if(result.data && result.data!=="")
			{
				let pos = usuarios.findIndex((u: Usuario) => u.dni === usuario.dni);
				let newData = [ ...usuarios ];
				newData[pos] = {...result.data[0],id:usuario.id};
				setUsuarios([ ...newData ]);
				launchNotification({type:"success",title:translate('modificacion'),message:`${translate('msg-notificacion-modificar-usuario')}.`})
				//usuario.expatriado===true && 
				if(ficherosExpatriado && usuario.expatriado===true){
					adjuntarFicherosExpatriado(usuario.idEmpleado, ficherosExpatriado)
				}
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	return(
		<>
		<UsuariosExpatriadosScreen
			data={usuarios}
			permisosUser={permisosUser}
			handleUpdate={updateUsuario}
			{...props}
		/>
		</>
	);
};